import { REST_schema } from "../../@types/sharedSchema";

/** The `code` either portal's server answers with (v1: SalesTrainingErrorResponse, v2: SalesTrainingV2ErrorResponse). */
export type SalesTrainingErrorCode =
  | REST_schema.SalesTrainingErrorResponse["code"]
  | REST_schema.SalesTrainingV2ErrorResponse["code"];

/**
 * A failed sales-training request (v1 or v2), carrying the server's own `status` and `code` (FORBIDDEN / NOT_PUBLISHED /
 * NOT_FOUND, and for v2 INVALID / OWNER / LIMIT / NOT_READY), so a page can tell "not published yet" from "not allowed"
 * from "offline".
 */
export class SalesTrainingError extends Error {
  /** HTTP status. `0` when the request never got a response (offline, DNS, CORS). */
  readonly status: number;
  /** The server's `code` field, when the body was JSON. */
  readonly code: SalesTrainingErrorCode | null;

  constructor(message: string, status: number, code: SalesTrainingErrorCode | null | undefined) {
    super(message);
    this.name = "SalesTrainingError";
    this.status = status;
    this.code = code ?? null;
    // tsconfig targets es5, where subclassing a built-in breaks the prototype chain
    // and `instanceof` silently returns false.
    Object.setPrototypeOf(this, SalesTrainingError.prototype);
  }
}

export function isSalesTrainingError(error: unknown): error is SalesTrainingError {
  if (error instanceof SalesTrainingError) return true;
  return (error as { name?: string } | null)?.name === "SalesTrainingError";
}
